/**
 * MCP 协议命令字和帧格式常量定义
 * 定义 STM32 与上位机通信的命令字枚举、帧格式常量、波特率和错误码
 */

/** MCP 命令字枚举 */
export enum McpCmd {
  // 控制命令 (0x00-0x0F)
  SET_MOTOR_STATE    = 0x01,  // 设置电机状态
  SET_SPEED_REF      = 0x02,  // 设置转速参考值
  SET_TORQUE_REF     = 0x03,  // 设置转矩参考值
  SET_ID_REF         = 0x04,  // 设置 d 轴电流参考
  SET_IQ_REF         = 0x05,  // 设置 q 轴电流参考

  // PID 参数命令 (0x10-0x1F)
  SET_PID_ID         = 0x10,  // 设置 Id 环 PID
  SET_PID_IQ         = 0x11,  // 设置 Iq 环 PID
  SET_PID_SPEED      = 0x12,  // 设置速度环 PID
  SET_PID_POSITION   = 0x13,  // 设置位置环 PID
  GET_PID_ID         = 0x14,  // 查询 Id 环 PID
  GET_PID_IQ         = 0x15,  // 查询 Iq 环 PID
  GET_PID_SPEED      = 0x16,  // 查询速度环 PID
  GET_PID_POSITION   = 0x17,  // 查询位置环 PID

  // 遥测命令 (0x20-0x2F)
  GET_TELEMETRY      = 0x20,  // 请求单帧遥测
  START_STREAMING    = 0x21,  // 启动遥测流
  STOP_STREAMING     = 0x22,  // 停止遥测流

  // 自动整定命令 (0x30-0x3F)
  START_AUTO_TUNE    = 0x30,  // 启动自动整定
  STOP_AUTO_TUNE     = 0x31,  // 停止自动整定

  // 参数辨识命令 (0x40-0x4F)
  START_IDENTIFICATION = 0x40, // 启动参数辨识
  STOP_IDENTIFICATION  = 0x41, // 停止参数辨识
  GET_MOTOR_PARAMS     = 0x42, // 获取电机参数

  // 响应/上报命令 (0x80-0xFF)
  RSP_TELEMETRY        = 0x80, // 遥测数据响应
  RSP_PID_ACK          = 0x81, // PID 参数确认
  RSP_FAULT            = 0x82, // 故障上报
  RSP_AUTO_TUNE_PRG    = 0x83, // 自动整定进度
  RSP_AUTO_TUNE_RES    = 0x84, // 自动整定结果
  RSP_IDENTIFICATION_PRG = 0x85, // 辨识进度
  RSP_IDENTIFICATION_RES = 0x86, // 辨识结果
  RSP_MOTOR_PARAMS     = 0x87, // 电机参数响应
}

/** 串口信息 */
export interface SerialPortInfo {
  path: string;
  manufacturer?: string;
  serialNumber?: string;
  pnpId?: string;
  friendlyName?: string;
}

/** 帧头同步字 */
export const FRAME_HEADER = 0xAA;
/** 帧开销字节数（帧头 + CMD + LEN + CRC_L + CRC_H） */
export const FRAME_OVERHEAD = 5;
/** 数据段最大长度 */
export const MAX_DATA_LEN = 255;
/** 帧最大总长度 */
export const MAX_FRAME_SIZE = FRAME_OVERHEAD + MAX_DATA_LEN;

/** 支持的波特率列表 */
export const MCP_BAUD_RATES = [9600, 19200, 38400, 57600, 115200, 230400, 460800, 921600];

/** 错误码枚举 */
export enum ErrorCode {
  SERIAL_OPEN_FAILED = 1001,
  SERIAL_WRITE_FAILED = 1002,
  SERIAL_READ_FAILED = 1003,
  SERIAL_TIMEOUT = 1004,
  CRC_MISMATCH = 2001,
  INVALID_FRAME = 2002,
  UNKNOWN_CMD = 2003,
  INVALID_PID_PARAMS = 3001,
  INVALID_SAMPLE_RATE = 3002,
  RECORDING_FAILED = 3003,
  DB_INIT_FAILED = 4001,
  DB_QUERY_FAILED = 4002,
  DB_WRITE_FAILED = 4003,
  INTERNAL_ERROR = 5001,
  RESOURCE_EXHAUSTED = 5002,
}
